import { ArrayUtils } from '@everyboard/lib';
import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { CoordSet } from '../../jscaip/CoordSet';
import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class SaharaMobilityHeuristic extends PlayerMetricHeuristic {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getMetrics(node, _config) {
        const zeroMobilities = this.getMobilities(node.gameState, Player.ZERO);
        const oneMobilities = this.getMobilities(node.gameState, Player.ONE);
        // Inversing cause high number are bad for you, so good for the opponent
        return PlayerNumberTable.of(oneMobilities, zeroMobilities);
    }
    /**
     * @returns a list of number sorted from biggest to smallest
     *          each of those number represents the number of moves that one piece must take to reach the closest ally
     *          hence, the higher is considered the worst, as POSITIVE_INFINITY means surrounded
     */
    getMobilities(state, player) {
        const mobilities = [];
        for (const coord of state.allCoords()) {
            if (state.hasPieceBelongingTo(coord, player)) {
                mobilities.push(this.countMovesToClosestAlly(state, coord));
            }
        }
        ArrayUtils.sortByDescending(mobilities, (mobility) => mobility);
        return mobilities;
    }
    countMovesToClosestAlly(state, coord) {
        let exploredCoords = new CoordSet([coord]);
        let newWaveOfNeighbors = this.getLandingCoords(state, new CoordSet([coord]));
        let depth = 1;
        while (newWaveOfNeighbors.size() > 0) {
            const numberOfAllies = newWaveOfNeighbors.filter((c) => state.getPieceAt(c).equals(state.getPieceAt(coord)));
            const emptyNeighbors = newWaveOfNeighbors.filter((c) => state.getPieceAt(c).equals(FourStatePiece.EMPTY));
            if (numberOfAllies.size() > 0) {
                return depth;
            }
            else if (emptyNeighbors.size() === 0) {
                newWaveOfNeighbors = new CoordSet();
            }
            else {
                exploredCoords = exploredCoords.union(emptyNeighbors);
                newWaveOfNeighbors = this.getLandingCoords(state, emptyNeighbors);
                newWaveOfNeighbors = newWaveOfNeighbors.filter((c) => exploredCoords.contains(c) === false);
                depth++;
            }
        }
        return Number.POSITIVE_INFINITY;
    }
    getLandingCoords(state, coords) {
        let neighboringCoords = new CoordSet();
        for (const currentCoord of coords) {
            const neighbors = this.rules.getValidLandingCoords(state, currentCoord);
            for (const neighbor of neighbors) {
                if (coords.contains(neighbor) === false) {
                    neighboringCoords = neighboringCoords.addElement(neighbor);
                }
            }
        }
        return neighboringCoords;
    }
}
